import { useRef } from 'react';
import { debounce } from 'lodash';

const useDebounce = function useDebounce(callback) {
  let delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 300;
  let leading = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  const callbackRef = useRef(callback);
  callbackRef.current = callback;
  return useRef(debounce(function () {
    return callbackRef.current(...arguments);
  }, delay, {
    leading
  })).current;
};

export default useDebounce;